import { render, staticRenderFns } from "./projectEdit.vue?vue&type=template&id=dc08f7b2&scoped=true"
import script from "./projectEdit.vue?vue&type=script&lang=js"
export * from "./projectEdit.vue?vue&type=script&lang=js"
import style0 from "./projectEdit.vue?vue&type=style&index=0&id=dc08f7b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc08f7b2",
  null
  
)

export default component.exports